/**
 * The clinic THIS browser tab is looking at.
 *
 * The login token and the persisted auth state live in localStorage, which
 * every tab shares. Keeping the selected clinic only there meant switching in
 * one tab silently moved the others: their requests answered for the new
 * clinic while their screens still named the old one. So each tab keeps its
 * own clinic in sessionStorage (per tab, survives a reload), and every API
 * request sends it as X-Clinic-Id, which the backend checks against the
 * clinics the account holds. A new tab starts from the clinic last picked
 * anywhere, carried by the token.
 *
 * Stored as the clinic id, or 'all' for the multi-clinic view.
 */

const KEY = 'tab-clinic-id'

function read() {
  try { return sessionStorage.getItem(KEY) } catch { return null }
}

/** The header value for this tab, or null when the tab has not picked yet. */
export function tabClinicHeader() {
  return read()
}

/** This tab's clinic as the store holds it: an id, null for all, or undefined if unset. */
export function getTabClinic() {
  const value = read()
  if (value == null) return undefined
  return value === 'all' ? null : value
}

export function setTabClinic(clinicId) {
  try { sessionStorage.setItem(KEY, clinicId == null ? 'all' : clinicId) } catch { /* private mode: falls back to the token */ }
}

export function clearTabClinic() {
  try { sessionStorage.removeItem(KEY) } catch { /* nothing to clear */ }
}
